/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

export const _untranslated = [];

export const translateString = function (str, translations, data = {}) {
  if (typeof translations != "undefined" && translations && translations[str]) {
    str = translations[str];
  } else {
    if (str && str.length && !_untranslated.includes(str)) {
      _untranslated.push(str);
    }
  }

  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      str = str.replace(new RegExp("%" + key + "%", "g"), data[key]);
    }
  }

  return str;
};

window._untranslated = _untranslated;
